export default "__VITE_ASSET__D3Wn0C3W__"